import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { heroBg } from "../mock/mock";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden bg-white border-b border-gray-200">
      {/* Subtle technical background */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.14]"
        style={{ backgroundImage: `url(${heroBg})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/40" aria-hidden="true" />

      <div className="relative max-w-[1240px] mx-auto px-5 py-24 md:py-32">
        <div className="max-w-2xl animate-fade-up">
          <span className="inline-block font-heading font-bold uppercase tracking-[0.18em] text-[#D80000] text-sm md:text-base">
            Shiv Shakti Enterprises
          </span>
          <h1 className="font-heading text-[#1a1a1a] text-4xl md:text-5xl font-medium mt-3">
            Need it made?
          </h1>
          <h1 className="font-heading text-[#D80000] text-5xl md:text-7xl font-semibold mt-1 leading-tight">
            We&apos;ve got you covered.
          </h1>
          <p className="font-heading text-[#1a1a1a]/80 text-xl md:text-2xl font-medium mt-4">
            Your Global Partner in Manufacturing
          </p>
          <button
            onClick={() => navigate("/contact")}
            className="group mt-9 inline-flex items-center gap-2 bg-[#D80000] text-white font-semibold px-7 py-3.5 rounded-md hover:bg-[#b00000] hover:shadow-lg hover:-translate-y-0.5"
          >
            Get Started
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
